var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('HeaderComponent',{attrs:{"blur":_vm.NavIsOpen}}),_c('NavigationComponent',{on:{"is-open":(bool) => _vm.navIsOpen(bool)}}),_c('div',{class:[ _vm.NavIsOpen ? 'blur' : '' ],attrs:{"id":"content-wrapper"}},[_c('router-view')],1),_c('FooterComponent',{attrs:{"blur":_vm.NavIsOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }